import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "text-[14px] -translate-y-[1px]" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("a", {
        class: _normalizeClass(["rounded-full bg-mertl-blue hover:bg-mertl-dark-blue inline-flex justify-center text-white font-xs invisible-link items-center px-2 py-0.5 gap-1 -translate-y-0.5 whitespace-nowrap", { hidden: !$setup.visible }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {
            let newQuery = {
                ...$setup.route.query,
                ...{
                    startIndex: 1,
                },
            };
            delete newQuery.grade;
            delete newQuery.outerDiameter;
            delete newQuery.wallThickness;
            if ($setup.isShortLengthsOverview) {
                delete newQuery.material;
                delete newQuery.shape;
            }
            else if (newQuery.material && newQuery.shape) {
                for (const key of Object.keys(newQuery).reverse()) {
                    if (['material', 'shape'].includes(key)) {
                        delete newQuery[key];
                        break;
                    }
                }
            }
            $setup.router.push({
                query: newQuery,
            });
        }, ["prevent"]))
    }, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fab fa-mertl-close text-[8px]" }, null, -1 /* CACHED */)),
        _createElementVNode("span", _hoisted_1, _toDisplayString($setup.$t('Clear all filters')), 1 /* TEXT */)
    ], 2 /* CLASS */));
}
